import axios from 'axios'

axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.headers['Content-Type'] = 'application/json'

// $swoole
export const $swoole = axios.create({
  baseURL: import.meta.env.VITE_SWOOLE_ROOT,
})

// $zyc
export const $zyc = axios.create({
  baseURL: import.meta.env.VITE_ZYC_ROOT,
})

// $napi
export const $napi = axios.create({
  baseURL: import.meta.env.VITE_NAPI_ROOT,
})

// $ibs
export const $ibs = axios.create({
  baseURL: import.meta.env.VITE_IBS_ROOT,
})

// $ibs23
export const $ibs23 = axios.create({
  baseURL: import.meta.env.VITE_IBS23_ROOT,
})

// $uc
export const $uc = axios.create({
  baseURL: import.meta.env.VITE_UC_ROOT,
})

$ibs23.interceptors.response.use((response) => {
  const responseData = response.data

  if (responseData.code !== 200000000) {
    alert(responseData.msg)
  }

  return response
})
